import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold mb-4 uppercase tracking-wide">
              What Is Superbuy Spreadsheet?
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-5 leading-tight">
              Your Complete Research Organization System
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-6 text-sm md:text-base">
              Superbuy Spreadsheet is an organized research method that helps users discover products, compare information, analyze options, and improve their shopping workflow. Instead of browsing hundreds of pages manually, you can organize important information in one structured place for better, faster decisions.
            </p>

            <div className="space-y-4">
              {[
                { num: '01', title: 'Save Research Time', desc: 'Instead of browsing hundreds of pages manually, organize important information in one structured place.' },
                { num: '02', title: 'Compare Products Easily', desc: 'Use comparison tables to evaluate products, categories, prices, and features side by side.' },
                { num: '03', title: 'Make Better Decisions', desc: 'Access organized guides and data before completing purchasing decisions with confidence.' },
              ].map((item) => (
                <div key={item.num} className="flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 font-bold text-sm flex-shrink-0">
                    {item.num}
                  </span>
                  <div>
                    <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-1">{item.title}</h4>
                    <p className="text-foreground-600 text-xs leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20accessories%20flatlay%20on%20warm%20marble%20surface%20featuring%20classic%20analog%20watch%20with%20brown%20leather%20strap%20aviator%20sunglasses%20and%20premium%20leather%20wallet%20next%20to%20copper%20keychain%20and%20minimalist%20cardholder%20soft%20golden%20hour%20light%20casting%20subtle%20shadows%20refined%20editorial%20still%20life%20photography%20sophisticated%20neutral%20palette&width=800&height=600&seq=about-products-v2&orientation=landscape"
                alt="Superbuy Spreadsheet organized research workspace showing laptop with spreadsheet and product comparison tools"
                title="Superbuy Spreadsheet - Research Organization Workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-2xl bg-accent-100/80 backdrop-blur-sm flex items-center justify-center border border-accent-200/50">
              <span className="font-heading font-bold text-accent-700 text-center text-xs leading-tight">
                100+<br />Guides
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}